import React from 'react';
export function ProcessTimeline() {
  const steps = [{
    title: 'Discover',
    description: 'Initial discovery call to understand your objectives, timeline, and budget.'
  }, {
    title: 'Design',
    description: 'Custom proposal with venue options, activities, and detailed pricing.'
  }, {
    title: 'Confirm',
    description: 'Finalize selections, secure venues, and lock in preferred dates.'
  }, {
    title: 'Plan',
    description: 'Detailed planning of logistics, activities, and special requirements.'
  }, {
    title: 'Execute',
    description: 'On-site management with dedicated bilingual concierge team.'
  }, {
    title: 'Debrief',
    description: 'Post-event analysis, feedback collection, and ROI measurement.'
  }];
  return <section className="py-12 bg-[#F4E8D0]/30" data-id="element-203">
      <div className="container mx-auto px-4 md:px-6" data-id="element-204">
        <div className="max-w-3xl mx-auto text-center mb-8" data-id="element-205">
          <h2 className="text-3xl font-bold text-[#374047] mb-2" data-id="element-206">
            Our Process
          </h2>
          <p className="text-base text-[#374047]/80" data-id="element-207">
            A seamless journey from concept to execution.
          </p>
        </div>
        <div className="max-w-5xl mx-auto" data-id="element-208">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-209">
            {steps.map((step, index) => <div key={index} className="bg-white p-4 rounded-lg shadow-sm" data-id="element-210">
                <div className="flex items-center mb-2" data-id="element-211">
                  <div className="w-8 h-8 rounded-full bg-[#0099A1] text-white font-bold text-sm flex items-center justify-center mr-3" data-id="element-212">
                    {index + 1}
                  </div>
                  <h3 className="text-lg font-bold text-[#0099A1]" data-id="element-213">
                    {step.title}
                  </h3>
                </div>
                <p className="text-sm text-[#374047]/80" data-id="element-214">{step.description}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}